<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="CT1"><span class="ePub-BI">The Songs We Know Best</span></p>
<p class="IMG" id="page1"><img alt="image" height="251" src="images/OrchardinBloom_fmt.jpg" width="400"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm1.vue?4fe7da4f